import React from 'react';
import { Box, Typography } from '@mui/material';

export interface DetailRowProps {
  label: string;
  value?: React.ReactNode;
  mono?: boolean;
  labelWidth?: number;
}

/** A "label: value" row for detail/side panels. Renders nothing when value is
 *  empty, so callers can list optional fields without guarding each one. */
const DetailRow: React.FC<DetailRowProps> = ({ label, value, mono, labelWidth = 96 }) => {
  if (value == null || value === '') return null;
  return (
    <Box sx={{ display: 'flex', gap: 1.5, py: 0.5 }}>
      <Typography sx={{ width: labelWidth, flexShrink: 0, color: 'text.secondary', fontSize: 12.5 }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: 12.5, fontFamily: mono ? 'monospace' : undefined, wordBreak: 'break-word' }}>
        {value}
      </Typography>
    </Box>
  );
};

export default DetailRow;
